export default "__VITE_ASSET__d0087298__"